import React from "react";
import { Avatar, Box } from "@material-ui/core";

import { makeKey } from "../../utils/helpers";

import { NDAMarkers, SelectedUserLabel } from "./user.styles";
import { UserProps } from "./user.props";
import { UserRemoveButton } from "./components/user-remove-button/user-remove-button.component";

export const User = (props: UserProps) => {
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box>
        <Avatar
          title={`${props.user.firstName} ${props.user.lastName}`}
          alt={`${props.user.firstName} ${props.user.lastName}`}
          src={(props.user.profileImageUrl) ? props.user.profileImageUrl : "/profile.png" }
        />
      </Box>
      <Box flexGrow={1} ml={1}>
        <SelectedUserLabel>
          {props.user.firstName +' '+ props.user.lastName}
          {props.markers && (
            <NDAMarkers>
              {props.markers.map((marker, index) => (
                <span key={makeKey(["nda", index], marker.id)}>
                  {index === 0 ? "" : ", "}
                  {marker.label}
                </span>
              ))}
            </NDAMarkers>
          )}
        </SelectedUserLabel>
      </Box>
      <UserRemoveButton
        showIf={Boolean(props.onRemove)}
        id={props.user.id}
        isDisabled={props.isDisabled}
        onRemove={props.onRemove!}
      />
    </Box>
  );
};
